module.exports = "https://cwa.roocdn.com/_next/static/team.86d7b512.jpg";